import { useTypedSelector } from '@/store/store';
import { MenuItemTypes } from '@/typings/model';
import { selectMenuItemListByAlias } from '@/store/reducers/tager/menus';

export function useMenuItem<K extends MenuItemTypes>(key: K) {
  return useTypedSelector((state) => selectMenuItemListByAlias(state, key));
}
